import Main from "./pages/Main";
import Rooms from "./pages/Rooms";
import Boards from "./pages/Boards";
import Reservation from "./pages/Reservation";
import Direction from "./pages/Direction";
import Surroundings from "./pages/Surroundings";
import BoardDetail from "./pages/BoardDetail";
import NewBoard from "./pages/Boards/components/NewBoard";
import UpdateBoard from "./pages/Boards/components/UpdateBoard";
import RoomDetail from "./pages/RoomDetail";
import Admin from "./pages/Admin";
import Facilities from "./pages/Facility";
import NewFacility from "./pages/Facility/components/NewFacility";

const routes = [
  {
    path: "/",
    exact: true,
    component: Main
  },
  {
    path: "/room",
    exact: true,
    component: Rooms
  },
  {
    path: "/room/:id",
    exact: true,
    component: RoomDetail
  },
  {
    path: "/surrounding",
    component: Surroundings
  },
  {
    path: "/board",
    exact: true,
    component: Boards
  },
  {
    path: "/board/new",
    exact: true,
    component: NewBoard
  },
  {
    path: "/update/:id",
    component: UpdateBoard
  },
  {
    path: "/board/:id",
    exact: true,
    component: BoardDetail
  },
  {
    path: "/reservation",
    component: Reservation
  },
  {
    path: "/direction",
    component: Direction
  },
  {
    path: "/facility",
    exact: true,
    component: Facilities
  },
  {
    path: "/facility/new",
    exact: true,
    component: NewFacility
  },
  {
    path: "/admin",
    component: Admin
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/App/pages/Home/routes.js